import CreateLabelPage from './create-label-page';

/** The Create Label page, filled in from the label in the route's :id. */
export default function CloneLabelPage() {
  return <CreateLabelPage pageMode="clone" />;
}
